import { connect } from 'react-redux';
import { lazy, Suspense } from 'react';
import 'typeface-roboto';
import 'typeface-noto-sans';
import "@fontsource/source-sans-pro"

// Rapids GUI Library
import { ProvideTheme, Button } from 'rapids-gui-library';

// App Components
import Challenge from "./sites/challenge";
import AgentAndRapids from "./sites/agent_and_rapids";

global.is_logged_in_secure = false;
global.is_dark_theme = false;

function App({userInfo, pageInfo, ...props}) {

  return (
      <>
      {(window._env_.APP_SITE === 'agent' || window._env_.APP_SITE === 'rapids') && global.is_dark_theme &&
          <ProvideTheme themeType={'dark'}>
              <AgentAndRapids />
          </ProvideTheme>
      }
      {(window._env_.APP_SITE === 'agent' || window._env_.APP_SITE === 'rapids') && !global.is_dark_theme &&
          <ProvideTheme themeType={'default'}>
              <AgentAndRapids />
          </ProvideTheme>
      }
      {(window._env_.APP_SITE === 'challenge') &&
          <ProvideTheme themeType={'challenge'}>
              <Challenge />
          </ProvideTheme>
      }

    </>
  );
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.userInfo,
    pageInfo: state.pageInfo
  }
}

export default connect(mapStateToProps)(App);
